// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 637 ? "swipeableDrawer" : chunkId) + "." + {"2":"c8054eac","368":"dde6e35b","541":"73ab5036","637":"334aa9b2","931":"200e2cb0"}[chunkId] + ".chunk.js";
};